import {
    type FC,
    useLayoutEffect,
    useRef,
    useState,
} from "react";
import ReportTable from "../../../Common/Reporting/Table/ReportTable";

interface Props {
    query: string;
    layers: number;
}

export const DashboardTable: FC<Props> = ({
    query,
    layers,
}) => {
    const ref = useRef<HTMLDivElement>(null);

    const [ topPadding, setTopPadding ] = useState(0);
    const [ height, setHeight ] = useState(0);

    useLayoutEffect(() => {
        const observer = new ResizeObserver((entries) => {
            if(!entries.length) {
                return;
            }

            setHeight(entries[0].contentRect.height);
        });

        if(ref.current) {
            const { top, height } = ref.current.getBoundingClientRect();

            setTopPadding(top);
            setHeight(height);

            observer.observe(ref.current);
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div
            ref={ref}
            className="w-full max-h-full overflow-auto"
        >
            <ReportTable
                showInitialLoading
                query={query}
                onLoaded={(page, err) => {
                    if(err) {
                        console.error("Failed to load dashboard table", err);
                    }
                }}
                cache={true}
                loadAllData={true}
                parentElement={ref.current ?? undefined}
                layers={layers}
                topPadding={topPadding}
                height={height}
            />
        </div>
    );
};
